export default [
  {
    id: 1,
    title: "Como obter um certificado SSL para o domínio personalizado do seu Central de Ajuda",
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Michael' },
    category: {
      slug: 'configuration',
      icon: '📦',
        name: 'Configuração & Instalação',
    },
    views: 3400,
  },
  {
    id: 2,
    title: 'Configurar seu primeiro portal de Central de Ajuda',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'John' },
        category: { slug: 'onboarding', icon: '🧑‍🍳', name: 'Integração Inicial' },
    views: 400,
  },
  {
    id: 3,
    title: 'Práticas recomendadas para organizar o conteúdo do seu Central de Ajuda',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Fernando' },
    category: { slug: 'best-practices', icon: '⛺️', name: 'Melhores Práticas' },
    views: 400,
  },
  {
    id: 4,
    title: 'Personalizando a aparência do seu Central de Ajuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Jane' },
    category: { slug: 'design', icon: '🎨', name: 'Design' },
    views: 400,
  },
  {
    id: 5,
    title: 'Integrando seu Central de Ajuda com ferramentas de terceiros',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sarah' },
    category: {
      slug: 'integrations',
      icon: '🔗',
      name: 'Integrações',
    },
    views: 2800,
  },
  {
    id: 6,
    title: 'Gerenciando permissões de usuário no seu Central de Ajuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Alex' },
    category: {
      slug: 'administration',
      icon: '🔐',
      name: 'Administração',
    },
    views: 1200,
  },
  {
    id: 7,
    title: 'Criando e gerenciando seções de FAQ',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Emily' },
    category: {
      slug: 'content-management',
      icon: '📝',
      name: 'Gerenciamento de Conteúdo',
    },
    views: 5600,
  },
  {
    id: 8,
    title: 'Implementando funcionalidade de busca no seu Central de Ajuda',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'David' },
    category: {
      slug: 'features',
      icon: '🔍',
      name: 'Funcionalidades',
    },
    views: 1800,
  },
  {
    id: 9,
    title: 'Análise de métricas de uso do seu Central de Ajuda',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Rachel' },
    category: {
      slug: 'analytics',
      icon: '📊',
      name: 'Análise de Métricas',
    },
    views: 3200,
  },
  {
    id: 10,
    title: 'Configurar suporte multilinguagem no seu Central de Ajuda',
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Carlos' },
    category: {
      slug: 'localization',
      icon: '🌍',
      name: 'Localização',
    },
    views: 900,
  },
  {
    id: 11,
    title: 'Criando tutoriais interativos para seus produtos',
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Olivia' },
    category: {
      slug: 'education',
      icon: '🎓',
      name: 'Educação',
    },
    views: 4100,
  },
  {
    id: 12,
    title: 'Implementando um sistema de feedback no seu Central de Ajuda',  
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Nathan' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
      name: 'Engajamento do Usuário',
    },
    views: 750,
  },
  {
    id: 13,
    title: 'Otimizando o conteúdo do seu Central de Ajuda para SEO',  
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sophia' },
    category: {
      slug: 'seo',
      icon: '🚀',
      name: 'SEO',
    },
    views: 2900,
  },
  {
    id: 14,
    title: 'Criando uma base de conhecimento para equipes internas',
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Daniel' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
      name: 'Recursos Internos',
    },
    views: 1500,
  },
];
